
import { SET_SECTION_FILTERS, UPDATE_SECTION_FILTER, TOGGLE_ALL_SECTIONS,SET_FILTER_COUNT } from "../reducers/SectionFilterReducer/sectionFilterReducer";


// Set all section filters (used initially)
export const setSectionFilters = (filters) => ({
    type: SET_SECTION_FILTERS,
    payload: filters,
});

// Update a single section's checked status
export const updateSectionFilter = (index, checked) => ({
    type: UPDATE_SECTION_FILTER,
    payload: { index, checked },
});

// Toggle all sections at once
export const toggleAllSections = (checked) => ({
    type: TOGGLE_ALL_SECTIONS,
    payload: checked,
});
export const setFilterCount = (count) => ({
    type: SET_FILTER_COUNT,
    payload: count,
});